(function menoplayCartLimitModule(window, document) {
  "use strict";

  var config = window.MenoPlayCartLimitConfig || {};
  var variantIds = new Set((config.variantIds || []).map(String));
  var originalFetch = window.fetch.bind(window);
  var mutationQueue = Promise.resolve();

  function packageError() {
    var error = new Error("Solo puedes tener un paquete de MenoPlay en el carrito. Para cambiar tu selección, usa la opción de reemplazo en el carrito.");
    error.name = "MenoPlayCartPackageError";
    return error;
  }

  function existingOneTimePackageHandoff() {
    var error = packageError();
    error.menoPlayExistingOneTimeHandoff = true;
    document.dispatchEvent(
      new CustomEvent("menoplay:cart:existing-one-time-package"),
    );
    return error;
  }

  function canHandoffToExistingOneTimePackage(cart, addedItems) {
    var cartItems = cart.items || [];
    var existingLine = cartItems[0];
    return (
      cartItems.length === 1 &&
      addedItems.length === 1 &&
      !addedItems[0].selling_plan &&
      isAllowedIncomingAddQuantity(addedItems[0].quantity) &&
      isOneTimeMenoPlayLine(existingLine) &&
      isAllowedPackageQuantity(existingLine.quantity)
    );
  }

  function packageQuantityError() {
    var error = new Error("Los paquetes de MenoPlay solo permiten 1, 2 o 3 frascos.");
    error.name = "MenoPlayCartPackageError";
    return error;
  }

  function isAllowedPackageQuantity(quantity) {
    quantity = Number(quantity);
    return Number.isInteger(quantity) && quantity >= 1 && quantity <= 3;
  }

  function isAllowedIncomingAddQuantity(quantity) {
    if (
      quantity == null ||
      (typeof quantity === "string" && quantity.trim() === "")
    ) {
      quantity = 1;
    }
    return isAllowedPackageQuantity(quantity);
  }

  function isMenoPlayLine(line) {
    var identity = [
      line && line.product_handle,
      line && line.handle,
      line && line.product_title,
      line && line.title,
    ]
      .filter(Boolean)
      .join(" ");
    return (
      variantIds.has(String(line && line.variant_id)) || /menoplay/i.test(identity)
    );
  }

  function getMenoPlayLines(cart) {
    return (cart.items || []).filter(isMenoPlayLine);
  }

  function isOneTimeMenoPlayLine(line) {
    return isMenoPlayLine(line) && !line.selling_plan_allocation;
  }

  function getOneTimeMenoPlayLines(cart) {
    return (cart.items || []).filter(isOneTimeMenoPlayLine);
  }

  function isSubscriptionMenoPlayLine(line) {
    return isMenoPlayLine(line) && line.selling_plan_allocation;
  }

  function getSubscriptionMenoPlayLines(cart) {
    return (cart.items || []).filter(isSubscriptionMenoPlayLine);
  }

  function requestPath(input) {
    var url = input && input.url ? input.url : input;
    return new URL(String(url), window.location.origin).pathname;
  }

  function cartUrl(path) {
    return (
      ((window.theme && window.theme.routes && window.theme.routes.cart) || "/cart") +
      path
    );
  }

  function parseBody(body) {
    var values = {};
    var params;
    if (!body) return values;
    if (typeof body === "string") {
      try {
        return JSON.parse(body);
      } catch (error) {
        params = new URLSearchParams(body);
      }
    } else if (body instanceof URLSearchParams) {
      params = body;
    } else if (typeof FormData !== "undefined" && body instanceof FormData) {
      params = new URLSearchParams();
      body.forEach(function append(value, key) {
        params.append(key, value);
      });
    } else {
      return values;
    }
    params.forEach(function assign(value, key) {
      values[key] = value;
    });
    return values;
  }

  function findLine(cart, id) {
    var key = String(id);
    return (cart.items || []).find(function matches(line, index) {
      return (
        String(line.key) === key ||
        String(line.variant_id) === key ||
        String(index + 1) === key
      );
    });
  }

  function getAddedMenoPlayItems(payload) {
    var items = Array.isArray(payload.items) ? payload.items : [payload];
    return items.filter(function matches(item) {
      return variantIds.has(String(item && item.id));
    });
  }

  function addContainsMenoPlay(payload) {
    return getAddedMenoPlayItems(payload).length > 0;
  }

  function validateMutation(cart, path, payload) {
    if (/\/cart\/add\.js$/.test(path)) {
      var addedItems = getAddedMenoPlayItems(payload);
      if (canHandoffToExistingOneTimePackage(cart, addedItems)) {
        throw existingOneTimePackageHandoff();
      }
      if (addedItems.some(function hasInvalidQuantity(item) {
        return !isAllowedIncomingAddQuantity(item.quantity);
      })) {
        throw packageQuantityError();
      }
      if (
        addContainsMenoPlay(payload) &&
        (getMenoPlayLines(cart).length > 0 || getAddedMenoPlayItems(payload).length > 1)
      ) {
        throw packageError();
      }
      return;
    }

    if (/\/cart\/change\.js$/.test(path)) {
      var changedLine = findLine(cart, payload.id || payload.line);
      if (
        isMenoPlayLine(changedLine) &&
        Number(payload.quantity) > 3
      ) {
        throw packageQuantityError();
      }
      return;
    }

    if (/\/cart\/update\.js$/.test(path)) {
      var updates = payload.updates || {};
      Object.keys(updates).forEach(function validateUpdate(id) {
        if (
          isMenoPlayLine(findLine(cart, id)) &&
          Number(updates[id]) > 3
        ) {
          throw packageQuantityError();
        }
      });
      Object.keys(payload).forEach(function validateFormUpdate(key) {
        var match = /^updates\[(.+)\]$/.exec(key);
        if (
          match &&
          isMenoPlayLine(findLine(cart, match[1])) &&
          Number(payload[key]) > 3
        ) {
          throw packageQuantityError();
        }
      });
    }
  }

  function fetchCart() {
    return originalFetch(cartUrl(".js"), { credentials: "same-origin" }).then(
      function parseCart(response) {
        if (!response.ok) throw new Error("Unable to verify the cart quantity.");
        return response.json();
      },
    );
  }

  function blockedResponse(error) {
    return new Response(
      JSON.stringify({
        status: 422,
        description: error.message,
          menoplay_existing_one_time_handoff: Boolean(
            error.menoPlayExistingOneTimeHandoff,
          ),
      }),
      { status: 422, headers: { "Content-Type": "application/json" } },
    );
  }

  function enqueueMutation(request) {
    var task = mutationQueue.then(request, request);
    mutationQueue = task.catch(function ignoreFailure() {});
    return task;
  }

  function registerVariantIds(ids) {
    String(ids || "")
      .split(",")
      .filter(Boolean)
      .forEach(function register(id) {
        variantIds.add(String(id));
      });
  }

  function beginReplacement(key, replacementVariantId) {
    return fetchCart().then(function verify(cart) {
      var lines = getMenoPlayLines(cart);
      var line = (cart.items || []).find(function matchesKey(item) {
        return String(item.key) === String(key);
      });
      if (
        !line &&
        lines.length === 1 &&
        String(lines[0].variant_id) === String(replacementVariantId)
      ) {
        line = lines[0];
      }
      if (
        !line ||
        !isMenoPlayLine(line) ||
        lines.length !== 1 ||
        !variantIds.has(String(replacementVariantId))
      ) {
        throw packageError();
      }
      if (!isAllowedPackageQuantity(line.quantity)) throw packageQuantityError();
      return function sendReplacementAdd(input, init) {
        var path = requestPath(input);
        var addedItems = getAddedMenoPlayItems(parseBody(init && init.body));
        if (
          !/\/cart\/add\.js$/.test(path) ||
          addedItems.length !== 1 ||
          String(addedItems[0].id) !== String(replacementVariantId)
        ) {
          throw packageError();
        }
        if (!isAllowedIncomingAddQuantity(addedItems[0].quantity)) {
          throw packageQuantityError();
        }
        return originalFetch.call(window, input, init);
      };
    });
  }

  function subscriptionItem(payload) {
    var items = Array.isArray(payload.items) ? payload.items : [payload];
    var item = items[0] || {};
    if (
      items.length !== 1 ||
      !variantIds.has(String(item.id)) ||
      !item.selling_plan
    ) {
      throw packageError();
    }
    if (!isAllowedIncomingAddQuantity(item.quantity)) throw packageQuantityError();
    item.quantity = 1;
    return item;
  }

  function oneTimePackageItem(payload) {
    var items = Array.isArray(payload.items) ? payload.items : [payload];
    var item = items[0] || {};
    if (
      items.length !== 1 ||
      !variantIds.has(String(item.id)) ||
      item.selling_plan
    ) {
      throw packageError();
    }
    if (!isAllowedIncomingAddQuantity(item.quantity)) throw packageQuantityError();
    return item;
  }

  function snapshotLine(line) {
    var allocation = line.selling_plan_allocation;
    var sellingPlan = allocation && allocation.selling_plan && allocation.selling_plan.id;
    return {
      id: line.variant_id,
      quantity: line.quantity,
      properties: line.properties || {},
      selling_plan: sellingPlan,
    };
  }

  function addSnapshot(snapshot) {
    if (!isAllowedPackageQuantity(snapshot.quantity)) throw packageQuantityError();
    var body = new URLSearchParams();
    body.set("id", String(snapshot.id));
    body.set("quantity", String(snapshot.quantity));
    Object.keys(snapshot.properties).forEach(function addProperty(name) {
      body.set("properties[" + name + "]", String(snapshot.properties[name]));
    });
    if (snapshot.selling_plan) body.set("selling_plan", String(snapshot.selling_plan));
    return originalFetch.call(window, cartUrl("/add.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    }).then(function ensureAdded(response) {
      if (!response.ok) throw new Error("Unable to restore the MenoPlay package.");
    });
  }

  function removeLine(key) {
    return originalFetch.call(window, cartUrl("/change.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function ensureRemoved(response) {
      if (!response.ok) throw new Error("Unable to remove the MenoPlay package.");
      return response.json();
    });
  }

  function findSubscriptionLine(cart, item, addedLine) {
    return (cart.items || []).find(function matches(line) {
      var allocation = line.selling_plan_allocation;
      var sellingPlanId = allocation && allocation.selling_plan && allocation.selling_plan.id;
      return (
        (addedLine && String(line.key) === String(addedLine.key)) ||
        (String(line.variant_id) === String(item.id) && String(sellingPlanId) === String(item.selling_plan))
      );
    });
  }

  function findOneTimePackageLine(cart, item, addedLine) {
    return (cart.items || []).find(function matches(line) {
      return (
        (addedLine && String(line.key) === String(addedLine.key)) ||
        (isOneTimeMenoPlayLine(line) && String(line.variant_id) === String(item.id))
      );
    });
  }

  function replaceOneTimePackageQuantity(key, replacementVariantId, quantity) {
    return enqueueMutation(function replace() {
      var originalSnapshot;
      var addedLine;
      var sourceRemoved = false;

      return fetchCart().then(function verify(cart) {
        var lines = getMenoPlayLines(cart);
        var sourceLine = (cart.items || []).find(function matchesKey(line) {
          return String(line.key) === String(key);
        });
        if (
          !sourceLine ||
          !isOneTimeMenoPlayLine(sourceLine) ||
          lines.length !== 1
        ) {
          throw packageError();
        }
        if (!isAllowedPackageQuantity(sourceLine.quantity)) throw packageQuantityError();
        if (!isAllowedPackageQuantity(quantity)) throw packageQuantityError();
        originalSnapshot = snapshotLine(sourceLine);
        return beginReplacement(key, replacementVariantId);
      }).then(function removeSource(sendReplacementAdd) {
        return removeLine(key).then(function recordRemoval() {
          sourceRemoved = true;
          var body = new URLSearchParams();
          body.set("id", String(replacementVariantId));
          body.set("quantity", String(quantity));
          return sendReplacementAdd(cartUrl("/add.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body.toString(),
          });
        });
      }).then(function parseReplacement(response) {
        if (!response.ok) throw new Error("Unable to add the MenoPlay package.");
        return response.json();
      }).then(function verifyReplacement(added) {
        addedLine = added;
        return fetchCart();
      }).then(function confirmReplacement(cart) {
        var replacement = findOneTimePackageLine(cart, {
          id: replacementVariantId,
        }, addedLine);
        if (
          getMenoPlayLines(cart).length !== 1 ||
          !replacement ||
          !isAllowedPackageQuantity(replacement.quantity) ||
          Number(replacement.quantity) !== Number(quantity)
        ) {
          throw new Error("Unable to verify the MenoPlay package replacement.");
        }
        return cart;
      }).catch(function rollback(error) {
        var rollbackFailed = false;
        if (!sourceRemoved) throw error;

        return fetchCart().then(function removeReplacement(cart) {
          var replacement = findOneTimePackageLine(cart, {
            id: replacementVariantId,
          }, addedLine);
          if (!replacement) return null;
          return removeLine(replacement.key).catch(function markRemoveFailure() {
            rollbackFailed = true;
          });
        }).then(function restoreSource() {
          return addSnapshot(originalSnapshot).catch(function markRestoreFailure() {
            rollbackFailed = true;
          });
        }).then(function rethrow() {
          if (rollbackFailed) {
            throw new Error("Unable to restore the cart after the MenoPlay package replacement failed.");
          }
          throw error;
        });
      });
    });
  }

  function replaceOneTimePackagesWithSubscription(payload) {
    return enqueueMutation(function replace() {
      var item;
      var removedSnapshots = [];
      var addedLine;

      return fetchCart().then(function verify(cart) {
        var packages = getOneTimeMenoPlayLines(cart);
        if (!packages.length) return null;
        if (packages.some(function hasInvalidQuantity(line) {
          return !isAllowedPackageQuantity(line.quantity);
        })) {
          throw packageQuantityError();
        }

        item = subscriptionItem(payload);

        return originalFetch.call(window, cartUrl("/add.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [item] }),
        }).then(function parseAdd(response) {
          if (!response.ok) throw new Error("Unable to add the MenoPlay subscription.");
          return response.json();
        }).then(function removePackages(added) {
          addedLine = added;
          return fetchCart();
        }).then(function removeCurrentPackages(cartAfterAdd) {
          return getOneTimeMenoPlayLines(cartAfterAdd).reduce(function removeNext(chain, line) {
            return chain.then(function remove() {
              var snapshot = snapshotLine(line);
              return removeLine(line.key).then(function recordRemoval() {
                removedSnapshots.push(snapshot);
              });
            });
          }, Promise.resolve());
        }).then(function verifyReplacement() {
          return fetchCart().then(function verifyFinalCart(finalCart) {
            if (getOneTimeMenoPlayLines(finalCart).length) {
              throw new Error("Unable to remove the MenoPlay package.");
            }
            return finalCart;
          });
        });
      }).catch(function rollback(error) {
        var rollbackFailed = false;
        if (!addedLine) throw error;

        return Promise.all(removedSnapshots.map(function restoreSnapshot(snapshot) {
          return addSnapshot(snapshot).catch(function markRestoreFailure() {
            rollbackFailed = true;
          });
        })).then(function removeSubscription() {
          return fetchCart();
        }).then(function removeAddedSubscription(cart) {
          var addedSubscription = findSubscriptionLine(cart, item, addedLine);
          if (!addedSubscription) return null;
          return removeLine(addedSubscription.key).catch(function markRemoveFailure() {
            rollbackFailed = true;
          });
        }).then(function rethrow() {
          if (rollbackFailed) {
            throw new Error("Unable to restore the cart after the subscription replacement failed.");
          }
          throw error;
        });
      });
    });
  }

  function replaceSubscriptionWithOneTimePackage(payload) {
    return enqueueMutation(function replace() {
      var item;
      var removedSnapshots = [];
      var addedLine;

      return fetchCart().then(function verify(cart) {
        var subscriptions = getSubscriptionMenoPlayLines(cart);
        if (!subscriptions.length) return null;
        if (subscriptions.some(function hasInvalidQuantity(line) {
          return !isAllowedPackageQuantity(line.quantity);
        })) {
          throw packageQuantityError();
        }

        item = oneTimePackageItem(payload);

        return originalFetch.call(window, cartUrl("/add.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [item] }),
        }).then(function parseAdd(response) {
          if (!response.ok) throw new Error("Unable to add the MenoPlay package.");
          return response.json();
        }).then(function removeSubscriptions(added) {
          addedLine = added;
          return fetchCart();
        }).then(function removeCurrentSubscriptions(cartAfterAdd) {
          return getSubscriptionMenoPlayLines(cartAfterAdd).reduce(function removeNext(chain, line) {
            return chain.then(function remove() {
              var snapshot = snapshotLine(line);
              return removeLine(line.key).then(function recordRemoval() {
                removedSnapshots.push(snapshot);
              });
            });
          }, Promise.resolve());
        }).then(function verifyReplacement() {
          return fetchCart().then(function verifyFinalCart(finalCart) {
            if (getSubscriptionMenoPlayLines(finalCart).length) {
              throw new Error("Unable to remove the MenoPlay subscription.");
            }
            return finalCart;
          });
        });
      }).catch(function rollback(error) {
        var rollbackFailed = false;
        if (!addedLine) throw error;

        return Promise.all(removedSnapshots.map(function restoreSnapshot(snapshot) {
          return addSnapshot(snapshot).catch(function markRestoreFailure() {
            rollbackFailed = true;
          });
        })).then(function removePackage() {
          return fetchCart();
        }).then(function removeAddedPackage(cart) {
          var addedPackage = findOneTimePackageLine(cart, item, addedLine);
          if (!addedPackage) return null;
          return removeLine(addedPackage.key).catch(function markRemoveFailure() {
            rollbackFailed = true;
          });
        }).then(function rethrow() {
          if (rollbackFailed) {
            throw new Error("Unable to restore the cart after the package replacement failed.");
          }
          throw error;
        });
      });
    });
  }

  window.MenoPlayCartLimit = {
    beginReplacement: beginReplacement,
    getLines: getMenoPlayLines,
    registerVariantIds: registerVariantIds,
    replaceOneTimePackageQuantity: replaceOneTimePackageQuantity,
    replaceOneTimePackagesWithSubscription: replaceOneTimePackagesWithSubscription,
    replaceSubscriptionWithOneTimePackage: replaceSubscriptionWithOneTimePackage,
  };

  window.fetch = function guardedFetch(input, init) {
    var path = requestPath(input);
    if (
      !/\/cart\/(add|change|update)\.js$/.test(path) ||
      (input && input.url && !init)
    ) {
      return originalFetch.apply(window, arguments);
    }
    return enqueueMutation(function validateAndSend() {
      return fetchCart()
        .then(function validate(cart) {
          validateMutation(cart, path, parseBody(init && init.body));
          return originalFetch.call(window, input, init);
        })
        .catch(function onFailure(error) {
          if (error && error.name === "MenoPlayCartPackageError") return blockedResponse(error);
          throw error;
        });
    });
  };

  if (window.XMLHttpRequest) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function guardedOpen(method, url) {
      this.__menoplayCartLimitPath = requestPath(url);
      return originalOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function guardedSend(body) {
      var request = this;
      var path = this.__menoplayCartLimitPath;
      if (!/\/cart\/(add|change|update)\.js$/.test(path)) {
        return originalSend.apply(this, arguments);
      }
      enqueueMutation(function validateAndSend() {
        return fetchCart().then(function validate(cart) {
          validateMutation(cart, path, parseBody(body));
          originalSend.call(request, body);
        });
      }).catch(function onFailure(error) {
        if (error && error.name === "MenoPlayCartPackageError") {
              request.__menoplayExistingOneTimeHandoff = Boolean(
                error.menoPlayExistingOneTimeHandoff,
              );
          request.dispatchEvent(new Event("error"));
          return;
        }
        request.dispatchEvent(new Event("error"));
      });
    };
  }

  document.addEventListener(
    "submit",
    function registerProductForm(event) {
      var form = event.target.closest("form");
      var marker = form && form.querySelector("[data-menoplay-limit-product]");
      if (form && form.hasAttribute("data-menoplay-limit-product")) marker = form;
      if (marker) registerVariantIds(marker.getAttribute("data-menoplay-variant-ids"));
    },
    true,
  );
})(window, document);
